module.exports = __webpack_public_path__ + "assets/images/OLXProject/playstation-4-min.png";